import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { GrClose } from "react-icons/gr";
import { Colors } from "../../utils/colors";
import { Logo } from "../../assets/svg";
import { offCanvasProps } from "../../interface";
import Data from "../../utils/data";






const CanvasWrapper = styled.div<{ canvas: boolean }>`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: rgba(0, 0, 0, 0.9);
  right: ${(props) => (props.canvas ? "0" : "-100%")};
`;
const Canvas = styled.div<{ canvas: boolean }>`
 width: 100%;
  height: 100%;
  background: #ffffff;
  z-index: 100;
  transition: right 0.3s;
  right: ${(props) => (props.canvas ? "0" : "-100%")};
  @media (min-width: 768px) {
    width: 80%;
    right: ${(props) => (props.canvas ? "0" : "-100%")};
  };
  @media (min-width: 991px) {
    width: 20%;
    right: ${(props) => (props.canvas ? "0" : "-50%")};
  };
`;
const NavItems = styled.li<{ isActive: boolean }>`
  font-family: "Poppins", sans-serif;
  list-style: none;
  font-size: 16px;
  padding: 10px 12px;
  line-height: 24px;
  letter-spacing: 0.01em;
  font-weight: 500;
  font-style: normal;
  color: #5c5c5c;
  text-transform: capitalize;
  a {
    text-decoration: none;
    color: ${(prop) => (prop.isActive ? Colors.primaryColor : "black")};
  }
`;
const List = styled.ul`
  padding-top: 48px;
  width: 100%;
  justify-content: space-around;
  padding-left: 0px !important;
`;
const SiteLogo = styled.div`
  padding-top: 19px;
  @media (max-width: 575px) {
    a {
      svg {
        width: 121px !important;
        height: 35px !important;
        margin-right: 16px;
      }
    }
  }
`;
const OffCanvas = ({ setCanvas, canvas }: offCanvasProps) => {
  const strapiGlobal = Data();
  let location: string;
  const isBrowser = typeof window !== "undefined";
  if (isBrowser) {
    location = window.location.pathname;
  }
  return (
    <CanvasWrapper canvas={canvas} onClick={() => setCanvas(false)}>
      <Canvas className="position-fixed" canvas={canvas} onClick={(e) => e.stopPropagation()} >
        <div className="container">
          <SiteLogo className="d-flex justify-content-between align-items-center pt-3">
            <Link to="/" aria-label="stagro">
              <Logo />
            </Link>
            <GrClose className="fs-4" onClick={() => setCanvas(false)} style={{cursor:"pointer"}}/>
          </SiteLogo>

          <List className="text-decoration-none">
            {strapiGlobal.strapiLayout.navbar.map((item: any, index: number) => {
              return (
                <NavItems
                  key={index}
                  isActive={location === item.navbarLink.split("?")[0]}
                >
                  <Link to={item.navbarLink}>{item.navbarItem}</Link>
                </NavItems>
              );
            })}
            <NavItems
              isActive={true}
            >
              <Link to="/free-instagram-likes/?id=like">Free Instagram Likes</Link>
            </NavItems>
            <NavItems
              isActive={true}
            >
              <Link to="/free-instagram-followers/?id=followers">Free Instagram Followers</Link>
            </NavItems>
            <NavItems
              isActive={true}
            >
              <Link to="/free-instagram-views/?id=views">Free Instagram Views</Link>
            </NavItems>
          </List>
        </div>
      </Canvas>
    </CanvasWrapper>
  );
};
export default OffCanvas;

